
import React, { useState } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
//import DashboardHeader from '../../components/Other/DashboardHeader';
//import PageHeaderTitle from '../../components/pages/PageHeaderTitle';
//import PageContainer from '../../components/pages/PageContainer';
//import { t } from 'i18next';
import { createPaymentApi } from '../../api/user';
import { toast } from 'react-toastify';

const CheckoutForm = ({ closeModal, getCards }) => {
    const [error, setError] = useState(null);
    const [nameError, setNameError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [cardholderName, setCardholderName] = useState('');
    const [isDisable, setisDisable] = useState(false);
    const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setisDisable(true)
        if (!stripe || !elements) {
            setisDisable(false)
            return;
        }
        setLoading(true);
        const cardElement = elements.getElement(CardElement);
        // const { error, paymentMethod } = await stripe.createPaymentMethod({
        //     type: 'card',
        //     card: cardElement,
        // });

        const { token, error } = await stripe.createToken(cardElement);
        // console.log(token, "token");
        if (token) {
            createPayment(token)
        }
        setLoading(false);
        if (error) {
            setError(error.message);
            setisDisable(false)
        }
    };

    const createPayment = async (token) => {
        if (!cardholderName) {
            setNameError("Card Holder Name is required!")
            return;
        } else {
            const obj = {
                type: token?.type,
                name_on_card: cardholderName,
                last_four_digit: token?.card?.last4,
                token: token?.id
            }
            const res = await createPaymentApi(obj)
            // console.log(res, "res");
            if (res?.data?.data) {
                setisDisable(false)
                getCards()
                closeModal()
                toast.success(res.data.message)
            } else {
                setisDisable(false)
                toast.error(res.data.message)
            }
        }
    }

    return (
        <>

            <form disabled={isDisable ? true : false} onSubmit={handleSubmit} >
                <div className="mb-4"> {/* Field Container */}
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="card-element">
                        Credit or Debit Card
                    </label>
                    <div className="border rounded p-2">
                        <CardElement id="card-element" options={cardElementOptions} />
                    </div>
                </div>

                <div className="mb-4"> {/* Field Container */}

                    <input
                        type="text"
                        name="cardholderName"
                        placeholder="Card Holder Name"
                        value={cardholderName}
                        onChange={(e) => {
                            setCardholderName(e.target.value)
                            setisDisable(false)
                        }
                        }
                        className="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    />
                    <span style={{ color: "red" }}>{nameError}</span>
                </div>

                <div className="flex items-center justify-between"> {/* For button and potential content next to it */}
                    <button
                        type="submit"
                        disabled={isDisable ? true : false}
                        className="bg-primaryColor hover:bg-primaryColor text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    >
                        {loading ? 'Processing...' : 'Add Card'}
                    </button>
                    <button
                        onClick={closeModal}
                        className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    >
                        Close
                    </button>
                    {error && <div className="text-red-500 text-sm">{error}</div>}
                </div>

            </form>
        </>
    );
};

const cardElementOptions = {
    style: {
        base: {
            fontSize: '16px',
            color: '#32325d',
            fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
            '::placeholder': {
                color: '#aab7c4',
            },
        },
        invalid: {
            color: '#fa755a',
        },
    },
    hidePostalCode: true,
};
export default CheckoutForm;
